import { InjectionToken, Type } from "@angular/core";
import { environment } from "../../environments/environment"; // angular will choose the right environment file.


// Helpers
interface IInjectionTokenConfig {
  provideIn?: "root" | Type<any>;
  factory(): any;
}

const provideValue = (value: any, provideIn: "root" | Type<any> = "root"): IInjectionTokenConfig => {
  return {
    provideIn,
    factory: () => value,
  };
};


// Injection Tokens
export const BASE_API_URL = new InjectionToken("Base url for the Web.API based on the environment.", provideValue(environment.baseApiUrl));
// export const COMMUNICATION_MICROSERVICE_URL = new InjectionToken("Base url for Communication Microservice based on the environment.", provideValue(environment.communicationMicroserviceUrl));
// export const SSRS_PAGE_URL = new InjectionToken("Base url for SSRS Page based on the environment.", provideValue(environment.ssrsPageUrl));
export const IDLE_PERIOD_IN_SEC = new InjectionToken("Sets an idle period based on the environment.", provideValue(environment.idlePeriodInSec));
export const TIMEOUT_PERIOD_IN_SEC = new InjectionToken("Sets a timeout period based on the environment.", provideValue(environment.timeoutPeriodInSec));
